import { generateUtilityClass, generateUtilityClasses } from '../className';
export function getModalUtilityClass(slot) {
  return generateUtilityClass('MuiModal', slot);
}
const modalClasses = generateUtilityClasses('MuiModal', ['root', 'backdrop']);
export default modalClasses;